import {
	createOffer,
	createPDFOffer,
	createPDFDimensioning,
	fetchOfferWithItemsById,
	showAlertModal,
	updateOffer,
	isObject,
	getClientInfo,
	fetchLocationById,
} from "@/utils/utils";
import emitter from "@/utils/emitter";
import apiClient from "@/utils/apiClient";
import { cloneDeep } from "lodash";
async function probeCompositeOffer(id) {
	// Only probe when the id looks like a composite offer id (C… or CO…).
	const isCompositeId =
		typeof id === "string" && (/^C\d+$/.test(id) || /^CO\d+$/.test(id));

	if (!isCompositeId) {
		// Normal offers (plain numeric ids etc.) should not hit the composite endpoint at all.
		return null;
	}

	const realId = id.match(/^C\d+$/) ? id.slice(1) : id.slice(2);

	try {
		const resp = await apiClient.get(`/api/composite-offers/${realId}/`, {
			validateStatus: status => status === 200 || status === 404,
		});
		if (resp.status === 404) {
			return null;
		}
		return resp.data;
	} catch (err) {
		// Normal (non‑composite) offers may lead to 404 or cancelled requests here;
		// those are expected and should not spam the console.
		if (err && err.response && err.response.status === 404) {
			return null;
		}
		if (err && err.code === "ERR_CANCELED") {
			return null;
		}
		console.error("Unexpected error while probing composite:", err);
		return null;
	}
}

export default {
	data() {
		return {
			initialOfferProducts: [],
			isProductsChanged: false,
			discount: 0,
			clientId: null,
			locationId: null,
			offer: null,
			offerProducts: null,
			offerPaymentTerms: [],
			offeredProducts: null,
			offerInformation: {
				price_list_id: "",
				discount: 0,
				notes: "",
				totalFinalPrice: 0,
				totalPriceWithoutDiscount: 0,
			},
			client: null,
			location: null,
			initialLocation: null,
			offerId: null,
			isOfferButtonsInView: true,
			offerTypes: [
				{
					name: "IPA",
					type: 1,
					routeName: "",
					color: "#e32829",
				},
				{
					name: "Sanitare",
					type: 2,
					routeName: "OfferPlumbing",
					color: "#8774B3",
				},
				{
					name: "VMC",
					type: 3,
					routeName: "OfferVMC",
					color: "#57c0da",
				},
				{
					name: "Simple",
					type: 4,
					routeName: "OfferSimple",
					color: "black",
				},
				{
					name: "Technical Room",
					type: 5,
					routeName: "OfferTechnicalRoom",
					color: "#8D9B6C",
				},
				{
					name: "Ceiling",
					type: 6,
					routeName: "OfferCeiling",
					color: "#3777BB",
				},
				{
					name: "Walls",
					type: 7,
					routeName: "OfferWalls",
					color: "#F8AC8C",
				},
				{
					name: "Automation",
					type: 8,
					routeName: "OfferAutomation",
					color: "#1F4690",
				},
				{
					name: "FanCoilUnit",
					type: 9,
					routeName: "OfferFanCoilUnit",
					color: "#AB9E9A",
				},
				{
					name: "ThermalChannel",
					type: 10,
					routeName: "OfferThermalChannel",
					color: "#b269ab",
				},
				{
					name: "HeatPump",
					type: 11,
					routeName: "OfferPDC",
					color: "#F37928",
				},
				{
					name: "Vacuum",
					type: 12,
					routeName: "OfferVacuum",
					color: "#40BFB4",
				},
				{
					name: "Services",
					type: 13,
					routeName: "OfferServices",
					color: "blue",
				},
				{
					name: "IPA_NEW",
					type: 20,
					routeName: "OfferIPA",
					color: "#e32829",
				},
			],
			buttons: [
				{
					text: "Calculează produse",
					onClick: () => this.processRequiredProducts(),
					disabled: () => false,
					color: "success",
					visible: () =>
						this.$options.name === "OfferVMC" ||
						this.$options.name === "OfferPDC" ||
						this.$options.name === "OfferVacuum" ||
						this.$options.name === "OfferPlumbing" ||
						this.$options.name === "OfferCeiling" ||
						this.$options.name === "OfferIPA",
					dataCy: "calculeaza-produse",
				},
				{
					text: "Salvează oferta",
					onClick: this.createSaveOffer,
					disabled: () => !this.canSaveOffer,

					color: "success",
					visible: () => true,
				},
				{
					text: "Creează ofertă nouă",
					onClick: this.createNewOffer,
					disabled: () =>
						!this.offerId ||
						(this.$options.name === "OfferIPA" && this.needRecalc),
					color: "primary",
					visible: () => true,
				},
			],
			pdfOptions: {
				simple: [
					{
						text: "Ofertă cu preț",
						onClick: () =>
							createPDFOffer(this.offerId, 0, this.sortingPDF),
						disabled: () => !this.offerId,
						color: "primary",
					},
					{
						text: "Ofertă fără preț",
						onClick: () =>
							createPDFOffer(this.offerId, 1, this.sortingPDF),
						disabled: () => !this.offerId,
						color: "primary",
					},
				],
				vmc: [
					{
						text: "Ofertă cu preț",
						onClick: () => createPDFOffer(this.offerId, 0, 0),
						disabled: () => !this.offerId,
						color: "primary",
					},
					{
						text: "Ofertă fără preț",
						onClick: () => createPDFOffer(this.offerId, 1, 0),
						disabled: () => !this.offerId,
						color: "primary",
					},
					{
						text: "Ofertă generală",
						onClick: () => createPDFOffer(this.offerId, 2, 0),
						disabled: () => !this.offerId,
						color: "primary",
					},
					{
						text: "Dimensionare",
						onClick: () =>
							createPDFDimensioning(
								this.offerId,
								this.locationId,
								0
							),
						disabled: () => !this.offerId,
						color: "primary",
					},
				],
				ipa: [
					{
						text: "Ofertă cu preț",
						onClick: () => this.openOfferPDFMenu(0),
						disabled: () => !this.offerId,
						color: "primary",
					},
					{
						text: "Ofertă fără preț",
						onClick: () => this.openOfferPDFMenu(1),
						disabled: () => !this.offerId,
						color: "primary",
					},
					{
						text: "Ofertă generală",
						onClick: () => this.openOfferPDFMenu(2),
						disabled: () => !this.offerId,
						color: "primary",
					},
					{
						text: "Dimensionare",
						onClick: () =>
							createPDFDimensioning(
								this.offerId,
								this.locationId,
								0
							),
						disabled: () => !this.offerId,
						color: "primary",
					},
				],
			},
			measurementUnits: [
				{ value: 1, text: "m²" },
				{ value: 2, text: "m" },
				{ value: 3, text: "pungă" },
				{ value: 4, text: "buc" },
				{ value: 5, text: "l" },
				{ value: 6, text: "set" },
				{ value: 7, text: "cutie" },
				{ value: 8, text: "rolă" },
				{ value: 9, text: "km" },
				{ value: 10, text: "kg" },
				{ value: 11, text: "ora" },
			],
			loadProductTable: false,
			isChangedOfferPriceList: false,
			isDifferentCreator: true,
			isTechnicalCreator: false,
			onlyDiscountChanged: false,
			isCustomPDFHeaderEmpty: false,
		};
	},
	async created() {
		let offerAndProducts = {};

		if (!this.$route.params.offerId) {
			this.offerId = null;
		} else {
			this.offerId = this.$route.params.offerId;

			const compositeData = await probeCompositeOffer(this.offerId);

			if (compositeData) {
				this._hydrateComposite(compositeData);

				offerAndProducts = compositeData;
			} else {
				const isCompositeId =
					typeof this.offerId === "string" &&
					(/^C\d+$/.test(this.offerId) || /^CO\d+$/.test(this.offerId));
				if (isCompositeId) {
					throw new Error("Oferta compusă nu a putut fi încărcată. Verificați conexiunea sau încercați din nou.");
				}
				offerAndProducts = await fetchOfferWithItemsById(
					this.offerId,
					this
				);
				if (!offerAndProducts) {
					throw new Error("Offer not found");
				}
				this.offer = offerAndProducts.offer;
				if ("productDetailsData" in this) {
					this.productDetailsData = offerAndProducts.offer?.product_details ?? {};
				}
				this.offeredProducts = offerAndProducts.products;
				this.initialOfferProducts = JSON.parse(
					JSON.stringify(offerAndProducts.products)
				);

				this.recommendedProducts =
					offerAndProducts.recommended_products;
				this.discount = Number(this.offer.discount);
				this.offerPaymentTerms = this.offer.payment_terms;
			}
		}
		this.clientId = this.$route.params.clientId;
		this.client = await getClientInfo(this.clientId, this);
		this.locationId = this.$route.params.locationId;
		this.location = await fetchLocationById(this.locationId, this);

		// IPA: comp/cust come from offer (or composite); overwrite location with offer values. New offer starts with 0.
		if (this.$options.name === "OfferIPA" && this.offer) {
			const o = this.offer;
			if (o.compartmentation != null && o.compartmentation !== undefined) {
				this.location.compartmentation = Number(o.compartmentation);
			}
			if (o.customization != null && o.customization !== undefined) {
				this.location.customization = Number(o.customization);
			}
		}
		if (this.$options.name === "OfferIPA" && !this.offer) {
			// New offer: do not reuse comp/cust from location (they are per-offer, not persisted on location)
			this.location.compartmentation = 0;
			this.location.customization = 0;
		} else {
			this.location.compartmentation = this.location.compartmentation ?? 0;
			this.location.customization = this.location.customization ?? 0;
		}
		// UNITS data is now related to the offer in the back-end and not to the location
		this.location.units = offerAndProducts.units;
		// here we also store the units in the locationUnits variable for saving in the offer as
		// the location.units gets overwritten when location is updated
		this.locationUnits = offerAndProducts.units;
		this.initialLocation = JSON.parse(JSON.stringify(this.location));
		this.loadProductTable = true;
	},

	computed: {
		/**
		 * Determines whether the Save Offer button should be enabled.
		 * Applies different rules depending on whether the user is the creator or a technical user.
		 *
		 * @returns {boolean}
		 */
		canSaveOffer() {
			if (!this.isProductsChanged) return false;
			// Disable saving for OfferCeiling if recalculation is needed
			if (this.$options.name === "OfferIPA" && this.needRecalc) {
				return false;
			}
			if (
				this.$options.name === "OfferCeiling" &&
				this.productsNeedRecalculation
			) {
				return false;
			}
			// Block save for OfferPlumbing if recalculation is needed
			if (
				this.$options.name === "OfferPlumbing" &&
				this.productsNeedRecalculation
			) {
				return false;
			}
			// Case 1: User is the offer creator → allow any changes
			if (!this.isDifferentCreator) return true;

			// Case 2: User is not the creator and not technical → disallow save
			if (!this.isTechnicalCreator) return false;

			// Case 3: User is not the creator but is technical → allow only if only discount changed
			return this.evaluateOnlyDiscountChanged();
		},
	},

	methods: {
		async createNewOffer() {
			const comp = this.getEffectiveCompartmentation();
			if (
				this.$options.name === "OfferIPA" &&
				(comp === 1 || comp === 2)
			) {
				await this.saveCompositeOffer();
				return;
			}
			await this.createOffer();
		},

		/**
		 * Hydrates a composite offer (with multiple subdivisions) into component state.
		 * Populates offer, client, location, products, and related metadata.
		 *
		 * @param {Object} data - The full composite offer payload from the backend.
		 * @returns {void}
		 */
		_hydrateComposite(data) {
			// Store offer with comp/cust explicit (source for getEffectiveCompartmentation; avoids loss on location overwrite)
			const compVal = data.compartmentation != null && data.compartmentation !== undefined
				? Number(data.compartmentation) : (data.compartmentation ?? null);
			const custVal = data.customization != null && data.customization !== undefined
				? Number(data.customization) : (data.customization ?? null);
			this.offer = { ...data, compartmentation: compVal, customization: custVal };
			this.client = data.client_data || data.client || null;
			// Normalize and assign location data
			if (data.location_data) {
				this.location = data.location_data;
			} else if (typeof data.location === "number") {
				this.location = { id: data.location };
			} else {
				this.location = data.location || {};
			}
			if (!Array.isArray(this.location.rooms)) {
				this.location.rooms = [];
			}
			// Comp/cust on location for UI (until next fetchLocationById)
			if (compVal != null) this.location.compartmentation = compVal;
			if (custVal != null) this.location.customization = custVal;
			if ("productDetailsData" in this) {
				this.productDetailsData = data.product_details ?? {};
			}
			// Extract and link all subdivisions (floors, apartments, etc.)
			const subdivisions = Array.isArray(data.subdivisions)
				? data.subdivisions
				: [];
			this.offer.subdivisions = subdivisions;
			this.location.subdivisions = subdivisions;

			const allProducts = subdivisions.flatMap(s => s.products || []);
			this.offeredProducts = allProducts;
			this.initialOfferProducts = JSON.parse(JSON.stringify(allProducts));
			// Aggregate recommended products from each suboffer (composite has no own list)
			const offers = Array.isArray(data.offers) ? data.offers : [];
			const recommendedSet = new Set();
			for (const suboffer of offers) {
				const codes = suboffer?.recommended_products_codes;
				if (Array.isArray(codes)) {
					codes.forEach(code => recommendedSet.add(code));
				}
			}
			this.recommendedProducts = [...recommendedSet];
			// For IPA with compartmentation 1 or 2, restore per-unit recommended products so they show after reload
			const comp = this.getEffectiveCompartmentation();
			if (
				this.$options.name === "OfferIPA" &&
				(comp === 1 || comp === 2) &&
				Array.isArray(offers) &&
				typeof this.getUnitIds === "function"
			) {
				const unitIds = this.getUnitIds();
				this.recommendedProductsByUnit = {};
				offers.forEach((offer, i) => {
					const uid = unitIds[i];
					if (uid !== undefined && uid !== null) {
						this.recommendedProductsByUnit[uid] =
							offer.recommended_products_codes || [];
					}
				});
			}
			this.discount = Number(data.discount ?? 0);
			this.offerPaymentTerms = Array.isArray(data.payment_terms)
				? [...data.payment_terms]
				: (this.offerPaymentTerms ?? []);
			if (!data.payment_terms && this.offerPaymentTerms?.length) {
				this.offer.payment_terms = [...this.offerPaymentTerms];
			}
			this.loadProductTable = true;
		},

		_hydrateNormal(offerAndProducts) {
			if (!offerAndProducts) throw new Error("Offer not found");
			this.offer = offerAndProducts.offer;
			if (this.offer?.offers?.length) {
				this.location = this.location || {};
				this.location.subdivisions = this.offer.offers.map(
					(sub, index) => ({
						id: sub.id,
						label: sub.name || `Subdiviziune ${index + 1}`,
						products: sub.items || [],
					})
				);
				this.loadProductTable = true;
			}
			this.recommendedProducts = [];
			this.specialProducts = [];
			this.offeredProducts = offerAndProducts.products;
			this.initialOfferProducts = JSON.parse(
				JSON.stringify(offerAndProducts.products)
			);
			this.recommendedProducts = offerAndProducts.recommended_products;
			this.discount = Number(this.offer.discount);
			this.offerPaymentTerms = this.offer.payment_terms;
		},

		/**
		 * Compares current offerProducts with the initial ones to detect additions, deletions or modifications.
		 * @returns {boolean} True if products were added, removed, or changed in quantity.
		 */
		hasModifiedProducts() {
			if (
				!Array.isArray(this.offerProducts) ||
				!Array.isArray(this.initialOfferProducts)
			)
				return false;

			const currentMap = new Map(
				this.offerProducts.map(p => [p.product_code, p.quantity])
			);
			const initialMap = new Map(
				this.initialOfferProducts.map(p => [p.product_code, p.quantity])
			);

			// Check for added or changed products
			for (const [code, qty] of currentMap.entries()) {
				if (!initialMap.has(code)) {
					return true; // Product added
				}
				if (qty !== initialMap.get(code)) {
					return true; // Quantity changed
				}
			}

			// Check for removed products
			for (const code of initialMap.keys()) {
				if (!currentMap.has(code)) {
					return true; // Product removed
				}
			}

			return false;
		},
		/**
		 * Fetches recommended VMC products based on the provided category.
		 * Sends an API request to get additional products filtered by category and price list.
		 * Updates the specialProducts property with the fetched data.
		 * Displays an alert in case of error or failure.
		 *
		 * @async
		 * @function getRecommendedProducts
		 * @param {string} category - The category of products to fetch.
		 */
		async getRecommendedProducts(category) {
			try {
				const response = await apiClient.get(
					`/api/additional-products/${category}/?price_list_id=${
						this.offerPriceList ? this.offerPriceList : ""
					}`
				);
				this.specialProducts = response.data;
			} catch (error) {
				console.error(
					"Error fetching recommended products:",
					error.response ? error.response.data : error.message
				);
				showAlertModal(
					this.$store,
					"A intervenit o eroare la preluarea produselor recomandate.",
					"danger",
					12000,
					error
				);
			}
		},
		/**
		 * Sets the custom sorting order for the generated PDF.
		 *
		 * @function setPDFCustomSorting
		 * @param {string} sorting - The sorting order to apply to the PDF.
		 */
		setPDFCustomSorting(sorting) {
			this.sortingPDF = sorting;
		},
		/**
		 * Updates the custom heading for the PDF.
		 * Marks the offer as changed by setting the isProductsChanged flag to true.
		 *
		 * @function setCustomPDFHeading
		 * @param {string} heading - The custom heading to set for the PDF.
		 */
		setCustomPDFHeading(heading) {
			this.offerInformation.customPDFHeading = heading;
			this.isProductsChanged = true;
		},
		/**
		 * Updates the price list ID for the offer and marks the offer as changed.
		 * If the price list changes, sets the isChangedOfferPriceList flag to true.
		 * Enables the save button by setting the isProductsChanged flag to true.
		 *
		 * @function updateOfferPriceList
		 * @param {number} priceListId - The ID of the new price list to set for the offer.
		 */
		updateOfferPriceList(priceListId) {
			if (this.offerPriceList && this.offerPriceList !== priceListId) {
				// here we set the changedOfferPriceList to true for displaying different confirmation messages
				this.isChangedOfferPriceList = true;
				// here we reset the isProductsChanged flag to make the save offer button available again
				// without having to modify any products
				this.isProductsChanged = true;
			}
			this.offerPriceList = priceListId;
		},
		/** Compartmentation: location (UI/sync), then offer (on load), then offerInformation, then 0. For new offer we do not use this.offer. */
		getEffectiveCompartmentation() {
			if (!this.offerId) {
				return Number(this.location?.compartmentation ?? this.offerInformation?.compartmentation ?? 0);
			}
			return Number(
				this.location?.compartmentation ??
					this.offer?.compartmentation ??
					this.offerInformation?.compartmentation ??
					0
			);
		},
		/** Customization: location (UI/sync), then offer (on load), then offerInformation, then 0. For new offer we do not use this.offer. */
		getEffectiveCustomization() {
			if (!this.offerId) {
				return Number(this.location?.customization ?? this.offerInformation?.customization ?? 0);
			}
			return Number(
				this.location?.customization ??
					this.offer?.customization ??
					this.offerInformation?.customization ??
					0
			);
		},
		/**
		 * Replaces the measurement unit text in each product with its corresponding numeral value based on a given list of measurement units.
		 * Each product's `measurement_unit` is matched against the provided `measurementUnits` array to find a corresponding unit. If a match is found,
		 * the product's `measurement_unit` is updated to the numeral value of the matching unit.
		 *
		 * @param {Object[]} products - An array of product objects. Each product should have a `measurement_unit` property.
		 * @param {Object[]} measurementUnits - An array of measurement unit objects, where each object has a `text` property (the text representation of the unit)
		 *                                       and a `value` property (the numeral representation of the unit).
		 * @returns {Object[]} The updated array of products with their `measurement_unit` properties replaced by their corresponding numeral values, if matches were found.
		 */
		replaceMeasurementUnits(products, measurementUnits) {
			// Some offer flows may temporarily hold products grouped in an object
			// (e.g. { "no-unit": [...] } or { [unitId]: [...] }). Normalize to array.
			if (!Array.isArray(products)) {
				if (products && typeof products === "object") {
					if (Array.isArray(products["no-unit"])) {
						products = products["no-unit"];
					} else {
						products = Object.values(products).flatMap(v =>
							Array.isArray(v) ? v : []
						);
					}
				} else {
					return [];
				}
			}

			// Loop through each product
			products.forEach(product => {
				// Find the matching measurement unit
				const match = measurementUnits.find(
					unit => unit.text === product.measurement_unit
				);

				// If a match is found, replace the measurement_unit with the numeral value
				if (match) {
					product.measurement_unit = match.value;
				}
			});

			return products;
		},
		/**
		 * Determines the offer type based on the current route name. It searches through an array of `offerTypes` to find
		 * an offer that matches the current route name. The `offerTypes` array is expected to be available within the context
		 * of where this method is defined.
		 *
		 * @returns {Object|undefined} Returns the matching offer object if found; otherwise, returns `undefined`. The offer object is expected
		 *                             to contain at least a `routeName` property that matches the current route name.
		 */
		getOfferType() {
			let routeName = this.$route.name;
			const offer = this.offerTypes.find(
				offer => offer.routeName === routeName
			);
			return offer;
		},
		/**
		 * Sends a POST request to save the ceiling setup configuration for a specific offer.
		 *
		 * This function is used to persist ceiling-specific data (such as total area and number of floors)
		 * related to an offer into the backend. It builds a payload using the provided values and includes
		 * the current offer's ID. If the values for `area` or `floors` are missing or empty strings,
		 * they will be converted to `null` to ensure proper backend validation.
		 *
		 * The API endpoint is expected to return a confirmation message or raise a validation error.
		 *
		 * @async
		 * @function saveCeilingSetup
		 * @param {Object} ceilingSetup - The configuration object for the ceiling setup.
		 * @param {string|number|null} ceilingSetup.area - The total area in square meters. Can be a number, string, or null.
		 * @param {string|number|null} ceilingSetup.floors - The number of floors. Can be a number, string, or null.
		 * @returns {Promise<Object>} Resolves with the API response data on successful save.
		 * @throws {Error} Throws an error if the API request fails due to validation errors or network issues.
		 *
		 * @example
		 * await saveCeilingSetup({ area: 120, floors: 2 });
		 *
		 * @example
		 * await saveCeilingSetup({ area: "", floors: "" }); // Will send null values to the API
		 */
		async saveCeilingSetup(ceilingSetup) {
			const payload = {
				offer: this.offerId,
				area: ceilingSetup.area || null,
				floors: ceilingSetup.floors || null,
			};
			try {
				const response = await apiClient.post(
					"/api/save-ceiling-setup/",
					payload
				);
				return response.data;
			} catch (error) {
				console.error(
					"Eroare la salvarea configurației plafonului:",
					error.response?.data || error.message
				);
				showAlertModal(
					this.$store,
					"A apărut o eroare la salvarea configurării plafonului. Vă rugăm reîncercați.",
					"danger",
					12000,
					error
				);
				throw error;
			}
		},

		/**
		 * Saves the vacuum setup data to the backend.
		 * @param {Object} vacuumSetup - The vacuum setup data to be saved.
		 * @returns {Promise<void>} A promise that resolves when the data is saved successfully.
		 */
		async saveVacuumSetup(vacuumSetup) {
			const transformedData = this.transformVacuumSetup(vacuumSetup);

			try {
				const response = await apiClient.post(
					"/api/save-vacuum-setup/",
					transformedData
				);
				return response.data;
			} catch (error) {
				console.error(
					"Error saving vacuum setup:",
					error.response ? error.response.data : error.message
				);
				showAlertModal(
					this.$store,
					"A intervenit o eroare la salvarea configurării pentru aspirare. Vă rugăm reîncercați.",
					"danger",
					12000,
					error
				);
				throw error;
			}
		},
		/**
		 * Saves the plumbing setup for a given offer.
		 * Sends the plumbing setup data along with the offer ID to the server to be saved.
		 * If an error occurs during the process, it logs the error and displays an alert to the user.
		 *
		 * @param {Array} plumbingSetup - The array of plumbing items to be saved.
		 * @param {string} offerId - The ID of the offer associated with the plumbing setup.
		 * @returns {Object} - The response data from the server if the request is successful.
		 * @throws {Error} - Throws an error if the save request fails.
		 */
		async savePlumbingSetup(plumbingSetup, offerId) {
			try {
				const payload = {
					offer: offerId, // Ensure you're passing the offer ID correctly
					plumbing_items: plumbingSetup, // The plumbing items array
				};
				const response = await apiClient.post(
					"/api/save-plumbing-setup/",
					payload
				);
				return response.data;
			} catch (error) {
				console.error(
					"Error saving plumbing setup:",
					error.response ? error.response.data : error.message
				);
				showAlertModal(
					this.$store,
					"A intervenit o eroare la salvarea configurării pentru sanitare. Vă rugăm reîncercați.",
					"danger",
					12000,
					error
				);
				throw error;
			}
		},
		/**
		 * Initiates the process of saving or creating an offer.
		 * If the current component is 'OfferVMC' and the location is not saved, it triggers 'handleOfferVMCAction'.
		 * Otherwise, it decides whether to save an existing offer or create a new one based on the presence of 'offerId'.
		 */
		async createSaveOffer() {
			if (this.$options.name === "OfferVMC" && !this.savedLocation) {
				this.isSaveOfferClicked = true;
				this.handleOfferVMCAction();
				return;
			}
			if (this.$options.name === "OfferIPA" && !this.savedLocation) {
				this.isSaveOfferClicked = true;
				this.handleOfferIPAAction();
				return;
			}

			// IPA composite: comp 1/2 or existing composite offer (CO76) – always save via composite endpoint
			const isCompositeId =
				this.offerId &&
				(/^CO\d+$/.test(String(this.offerId)) || /^C\d+$/.test(String(this.offerId)));
			const comp = this.getEffectiveCompartmentation();
			const useCompositePath =
				this.$options.name === "OfferIPA" &&
				((comp === 1 || comp === 2) || isCompositeId);

			if (this.offerId) {
				if (useCompositePath) {
					this.showRecommendedThermostatWarningIfNeeded?.();
					await this.saveCompositeOffer();
					return;
				}
				if (this.$options.name === "OfferIPA")
					this.showRecommendedThermostatWarningIfNeeded?.();
				this.saveOffer();
			} else {
				const compNew = this.getEffectiveCompartmentation();
				if (
					this.$options.name === "OfferIPA" &&
					(compNew === 1 || compNew === 2)
				) {
					this.showRecommendedThermostatWarningIfNeeded?.();
					await this.saveCompositeOffer();
					return;
				}
				if (this.$options.name === "OfferIPA")
					this.showRecommendedThermostatWarningIfNeeded?.();
				this.createOffer();
			}
		},
		/**
		 * Checks if the offer creator is different from the current user.
		 * @returns {boolean} True if the offer creator is different, false otherwise.
		 */
		checkDifferentOfferCreator() {
			if (this.offer) {
				const offerAgentId = this.offer.agent;
				const userId = JSON.parse(sessionStorage.getItem("userId"));
				this.isDifferentCreator = offerAgentId !== userId;
				return offerAgentId !== userId;
			}

			return false;
		},
		/**
		 * Evaluates if only the discount was changed and updates the internal flag.
		 * Logs detailed information for debugging.
		 * @returns {boolean} True if only discount was changed.
		 */
		evaluateOnlyDiscountChanged() {
			if (!this.offer) {
				this.onlyDiscountChanged = false;
				return false;
			}

			const originalDiscount = Number(this.offer.discount);
			const currentDiscount = Number(this.discount);

			const notesChanged =
				this.offerInformation.notes &&
				this.offerInformation.notes !== this.offer.notes;
			const hasProductChanges = this.hasModifiedProducts();
			const hasPaymentTermChanges =
				Array.isArray(this.offerPaymentTerms) &&
				this.offerPaymentTerms.length > 0;

			this.onlyDiscountChanged =
				originalDiscount !== currentDiscount &&
				!this.isChangedOfferPriceList &&
				!notesChanged &&
				!hasProductChanges &&
				!hasPaymentTermChanges;

			return this.onlyDiscountChanged;
		},
		/**
		 * Checks if the offer creator is marked as a technical user.
		 * @returns {boolean} True if the offer creator is a technical user.
		 */
		checkIfTechnicalCreator() {
			const offerAgentId = this.offer?.agent;
			const allUsers =
				JSON.parse(sessionStorage.getItem("myUsers")) || [];
			const offerCreator = allUsers.find(
				user => String(user.id) === String(offerAgentId)
			);

			this.isTechnicalCreator = !!(
				offerCreator && offerCreator.is_technicaluser
			);
			return this.isTechnicalCreator;
		},
		/**
		 * Handles the removal of custom header error.
		 */
		handleRemoveCustomHeaderError() {
			this.isCustomPDFHeaderEmpty = false;
		},
		/**
		 * Saves a composite (multi-subdivision) offer to the backend.
		 * Builds suboffers for each subdivision and submits them as a single composite offer payload.
		 *
		 * @async
		 * @returns {Promise<Object|null>} The saved composite offer data, or null if the operation failed.
		 *
		 * @description
		 * - Validates that the client and location exist before proceeding.
		 * - Builds a standardized payload including all subdivisions and their products.
		 * - Automatically maps measurement units to their numeric codes for backend compatibility.
		 * - Displays appropriate alerts for both success and failure cases.
		 */
		async saveCompositeOffer() {
			try {
				const location = this.location || {};
				const clientId = location?.client?.id || this.client?.id;
				const agentId =
					this.$store?.state?.user?.id ||
					sessionStorage.getItem("userId");
				const locationId = this.locationId || location?.id;

				// Validate mandatory fields before continuing
				if (!clientId || !locationId) {
					showAlertModal(
						this.$store,
						"Eroare: lipsesc clientul sau locația.",
						"danger",
						6000
					);
					return;
				}
				// Mapping of measurement unit names to backend numeric IDs
				const unitMap = {
					"m²": 1,
					m: 2,
					pungă: 3,
					buc: 4,
					l: 5,
					set: 6,
					cutie: 7,
					rolă: 8,
					km: 9,
					kg: 10,
					ora: 11,
				};
				const toMU = u => (typeof u === "number" ? u : unitMap[u] || 4);

				const subdivisions = this.buildSubdivisionsPayload();

				if (!subdivisions.length) {
					showAlertModal(
						this.$store,
						"Nu există subdiviziuni definite pentru ofertă.",
						"warning",
						4000
					);
					return;
				}

				// Recommended products to store on each suboffer (so they persist when composite is reloaded).
				// For IPA with compartmentation 1 or 2, use per-unit recommended codes; otherwise flat list.
				const comp = this.getEffectiveCompartmentation();
				const isIpaComp12 =
					this.$options.name === "OfferIPA" &&
					(comp === 1 || comp === 2);
				const unitIds =
					isIpaComp12 && typeof this.getUnitIds === "function"
						? this.getUnitIds()
						: [];
				const defaultRecommendedCodes = Array.isArray(
					this.recommendedProducts
				)
					? [...this.recommendedProducts]
					: [];
				// Create a separate sub-offer entry for each subdivision
				const suboffers = subdivisions.map((sub, index) => {
					const recommendedCodes =
						isIpaComp12 &&
						unitIds[index] !== undefined &&
						this.recommendedProductsByUnit &&
						Array.isArray(
							this.recommendedProductsByUnit[unitIds[index]]
						)
							? this.recommendedProductsByUnit[unitIds[index]]
							: defaultRecommendedCodes;
					return {
						client: clientId,
						agent: agentId,
						location: locationId,
						name: sub.label || `${location.name} - Subdiviziune`,
						notes: this.offer?.notes || "",
						recommended_products_codes: recommendedCodes,
						items: (sub.products || [])
							.filter(p => Number(p.quantity) > 0)
							.map(p => ({
								product_code: p.product_code,
								product_name: p.product_name || p.name || "",
								quantity: Math.min(
									Number(p.quantity?.toFixed(2)) || 0,
									99999999.99
								),

								price: Number(p.price ?? p.list_price ?? 0),
								discount: Number(p.discount ?? 0),
								measurement_unit: toMU(p.measurement_unit),
								category: p.category,
								assigned_sub_category: p.assigned_sub_category,
								is_deleted: false,
								manual_added: !!p.manual_added,
							})),
						units: [],
					};
				});
				const offerType = this.getOfferType()?.type || 20;
				suboffers.forEach(sub => (sub.type = offerType));

				const terms = (
					this.offerPaymentTerms ||
					this.offer?.payment_terms ||
					[]
				)
					.map(t => (typeof t === "string" ? t.trim() : t))
					.filter(t => t);

				const payload = {
					client: clientId,
					agent: agentId,
					location: locationId,
					name: `${location.name || "Locație"} - ofertă compusă`,
					notes: this.offer?.notes || "",
					type: offerType,
					suboffers,
					subdivisions,
				};

				if (terms.length) {
					payload.payment_terms = terms;
				}
				// IPA: per-composite compartmentation/customization (offer → location → offerInformation)
				payload.compartmentation = this.getEffectiveCompartmentation();
				payload.customization = this.getEffectiveCustomization();

				const isExistingComposite =
					this.offerId &&
					(/^CO\d+$/.test(String(this.offerId)) ||
						/^C\d+$/.test(String(this.offerId)));
				const compositeId = isExistingComposite
					? String(this.offerId).replace(/^CO/, "").replace(/^C/, "")
					: null;

				emitter.emit("trigger-overlay");
				let response;
				if (compositeId) {
					// Update existing composite: send only fields the backend can update (no suboffers replacement)
					const updatePayload = {
						compartmentation: payload.compartmentation,
						customization: payload.customization,
						name: payload.name,
						notes: payload.notes,
						payment_terms: payload.payment_terms,
						location: payload.location,
					};
					response = await apiClient.post(
						`/api/update-composite-offer/${compositeId}/`,
						updatePayload
					);
				} else {
					response = await apiClient.post(
						"/api/create-composite-offer/",
						payload
					);
				}

				this.offerId = String(response.data.id);
				this.offer = response.data;

				if (typeof this.saveProductDetailsForOffer === "function") {
					await this.saveProductDetailsForOffer();
				}

				this.$router.push({
					name: offerType.routeName,
					params: {
						offerId: this.offerId,
						clientId: this.clientId,
						locationId: this.locationId,
					},
				});

				if (Array.isArray(response.data.payment_terms)) {
					this.offerPaymentTerms = [...response.data.payment_terms];
				} else if (this.offerPaymentTerms?.length) {
					this.offer.payment_terms = [...this.offerPaymentTerms];
				}
				this.isProductsChanged = false;

				showAlertModal(
					this.$store,
					isExistingComposite
						? "Oferta compusă a fost actualizată cu succes!"
						: "Oferta compusă a fost salvată cu succes!",
					"success",
					3000
				);
				emitter.emit("trigger-overlay");
				return response.data;
			} catch (err) {
				console.error(
					"Eroare la salvarea ofertei compuse:",
					err?.response?.data || err
				);
				emitter.emit("trigger-overlay");
				showAlertModal(
					this.$store,
					"A apărut o eroare la salvarea ofertei compuse.",
					"danger",
					6000
				);
			}
		},

		/**
		 * Saves the existing offer details.
		 * Updates the offered products and offer products with measurement units, filters them based on quantity,
		 * and then sends the updated offer data to the server.
		 * On successful update, navigates to a specified route and displays a success message.
		 */
		async saveOffer() {
			try {
				if (
					this.offer &&
					this.offer.type === 4 &&
					!this.offerInformation.customPDFHeading
				) {
					showAlertModal(
						this.$store,
						"Vă rugăm completați câmpul Titlu ofertă PDF!",
						"danger",
						8000
					);
					this.isCustomPDFHeaderEmpty = true;
					return;
				}

				emitter.emit("save-offer-clicked");

				const isDifferent = this.checkDifferentOfferCreator();
				const isTechnical = isDifferent
					? this.checkIfTechnicalCreator()
					: false;

				if (isDifferent && !isTechnical) {
					await this.createOffer();
					return;
				}

				let offer = this.getOfferType();
				this.isSaveOfferClicked = true;
				if (this.offeredProducts) {
					this.offeredProducts = this.offeredProducts.filter(
						product => Number(product.quantity) > 0
					);
					this.offeredProducts = this.replaceMeasurementUnits(
						this.offeredProducts,
						this.measurementUnits
					);
				}
				if (this.offerProducts) {
					this.offerProducts = this.offerProducts.filter(
						product => Number(product.quantity) > 0
					);
					this.offerProducts = this.replaceMeasurementUnits(
						this.offerProducts,
						this.measurementUnits
					);
				}

				if (this.offeredProducts && !this.offerProducts) {
					this.offerProducts = [...this.offeredProducts];
				}

				// IPA: sync effective compartmentation/customization into offerInformation for save
				if (this.$options.name === "OfferIPA") {
					this.offerInformation.compartmentation =
						this.getEffectiveCompartmentation();
					this.offerInformation.customization =
						this.getEffectiveCustomization();
				}
				emitter.emit("trigger-overlay");
				await updateOffer(
					this,
					offer.type,
					this.offerId,
					this.offerProducts,
					this.offerInformation,
					this.offerPriceList,
					this.offerPaymentTerms,
					this.recommendedProducts,
					this.locationUnits
				)
					.then(async response => {
						this.offeredProducts = response;
						this.isProductsChanged = false;
						if (this.vacuumSetup) {
							await this.saveVacuumSetup(this.vacuumSetup);
						} else if (
							this.selectedPlumbingItems &&
							this.selectedPlumbingItems.length > 0
						) {
							await this.savePlumbingSetup(
								this.selectedPlumbingItems,
								this.offerId
							);
						}
						if (
							this.$options.name === "OfferCeiling" &&
							this.ceilingSetup
						) {
							await this.saveCeilingSetup(this.ceilingSetup);
						}
						if (
							typeof this.saveProductDetailsForOffer ===
							"function"
						) {
							await this.saveProductDetailsForOffer();
						}
						this.$router.push({
							name: offer.routeName,
							params: {
								offerId: this.offerId,
								clientId: this.clientId,
								locationId: this.locationId,
							},
						});

						if (
							this.isSaveOfferClicked &&
							this.location.isLocationChanged &&
							this.savedLocation
						) {
							if (this.isChangedOfferPriceList) {
								showAlertModal(
									this.$store,
									`<b>Locația</b> a fost salvată. <br> <b>Oferta</b> a fost salvată cu o altă listă de preț fată de cea inițială.`,
									"warning",
									8000
								);
							} else {
								showAlertModal(
									this.$store,
									`<b>Locația</b> si <b>oferta</b> au fost salvate cu succes.`,
									"success",
									2000
								);
							}
						} else if (this.isSaveOfferClicked) {
							if (this.isChangedOfferPriceList) {
								showAlertModal(
									this.$store,
									"Oferta a fost salvată cu o altă listă de preț fată de cea inițială.",
									"warning",
									8000
								);
							} else {
								showAlertModal(
									this.$store,
									"Oferta a fost salvată cu succes.",
									"success",
									2000
								);
							}
						}
						this.resetFlagsAfterOfferSave();
						emitter.emit("trigger-overlay");
					})
					.catch(error => {
						console.error("Error updating offer:", error);
						emitter.emit("trigger-overlay");
						showAlertModal(
							this.$store,
							"A apărut o eroare la salvarea ofertei. Vă rugăm să încercați din nou.",
							"danger",
							8000
						);
					});
			} catch (error) {
				console.error("Error saving offer:", error);
				emitter.emit("trigger-overlay");
				showAlertModal(
					this.$store,
					"A apărut o eroare la salvarea ofertei. Vă rugăm să încercați din nou.",
					"danger",
					8000
				);
			}
		},
		/**
		 * Creates a new offer.
		 * If the current component is 'OfferVMC' and the location is not saved, it triggers 'handleOfferVMCAction'.
		 * Otherwise, it validates the offer products and sends the new offer data to the server.
		 * On successful creation, sets the 'offerId', displays a success message, and navigates to a specified route.
		 */
		async createOffer() {
			let offer = this.getOfferType();
			if (
				offer &&
				offer.type === 4 &&
				!this.offerInformation.customPDFHeading
			) {
				showAlertModal(
					this.$store,
					"Vă rugăm completați câmpul Titlu ofertă PDF!",
					"danger",
					8000
				);
				this.isCustomPDFHeaderEmpty = true;
				return;
			}
			this.createNewOfferClicked = true;
			if (this.$options.name === "OfferVMC" && !this.savedLocation) {
				this.handleOfferVMCAction();
				return;
			}
			if (this.$options.name === "OfferIPA" && !this.savedLocation) {
				await this.handleOfferIPAAction();
				// `handleOfferIPAAction()` may open a dialog (needs user action) OR
				// mark location as already OK by setting `savedLocation=true`.
				if (!this.savedLocation) return;
			}
			emitter.emit("save-offer-clicked");

			if (this.offeredProducts.length > 0) {
				this.offerProducts = [...this.offeredProducts];
			}
			if (
				(!this.offerProducts && !this.isProductsChanged) ||
				(this.offeredProducts.length === 0 && !this.isProductsChanged)
			) {
				alert(
					"Nu se poate crea oferta, deoarece nu există produse adăugate (cantitate mai mare ca 0)."
				);
			} else {
				if (this.offeredProducts) {
					this.offeredProducts = this.replaceMeasurementUnits(
						this.offeredProducts,
						this.measurementUnits
					);
				}
				if (this.offerProducts) {
					this.offerProducts = this.replaceMeasurementUnits(
						this.offerProducts,
						this.measurementUnits
					);
				}
				this.offeredProducts = this.offeredProducts.filter(
					product => Number(product.quantity) > 0
				);
				this.offerProducts = this.offerProducts.filter(
					product => Number(product.quantity) > 0
				);
				// Block creation for OfferCeiling if recalculation is needed
				if (
					this.$options.name === "OfferCeiling" &&
					this.productsNeedRecalculation
				) {
					return showAlertModal(
						this.$store,
						"Setup-ul (suprafața/etajele) s-a modificat. Vă rugăm să recalculați produsele înainte de a crea oferta!",
						"warning",
						4000
					);
				}
				// Check if recalculation is needed for OfferPlumbing
				if (
					this.$options.name === "OfferPlumbing" &&
					this.productsNeedRecalculation
				) {
					showAlertModal(
						this.$store,
						"Setup-ul s-a modificat. Vă rugăm să recalculați produsele înainte de a salva oferta!",
						"warning",
						4000
					);
					return;
				}
				if (this.$options.name === "OfferIPA")
					this.showRecommendedThermostatWarningIfNeeded?.();
				// IPA: sync effective compartmentation/customization into offerInformation for create
				if (this.$options.name === "OfferIPA") {
					this.offerInformation.compartmentation =
						this.getEffectiveCompartmentation();
					this.offerInformation.customization =
						this.getEffectiveCustomization();
				}
				emitter.emit("trigger-overlay");
				try {
					await createOffer(
						this,
						offer.type,
						this.offerProducts,
						this.offerInformation,
						this.clientId,
						this.locationId,
						sessionStorage.getItem("userId"),
						this.offerPriceList,
						this.offerPaymentTerms,
						this.recommendedProducts,
						this.locationUnits
					).then(async response => {
						this.offerId = response.id.toString();
						this.$store.commit("setFetchedClientOffers", response);
						this.isProductsChanged = false;

						if (this.vacuumSetup) {
							await this.saveVacuumSetup(this.vacuumSetup);
						} else if (
							this.selectedPlumbingItems &&
							this.selectedPlumbingItems.length > 0
						) {
							await this.savePlumbingSetup(
								this.selectedPlumbingItems,
								this.offerId
							);
						} else if (
							this.$options.name === "OfferCeiling" &&
							this.ceilingSetup
						) {
							await this.saveCeilingSetup(this.ceilingSetup);
						}
						if (
							typeof this.saveProductDetailsForOffer ===
							"function"
						) {
							await this.saveProductDetailsForOffer();
						}

						if (this.savedLocation) {
							showAlertModal(
								this.$store,
								`<b>Locația</b> a fost salvată.</br> <b>Oferta</b> a fost creată cu succes.`,
								"success",
								3000
							);
						} else if (!this.savedLocation) {
							showAlertModal(
								this.$store,
								"Oferta a fost creată cu succes.",
								"success",
								3000
							);
						}
						emitter.emit("trigger-overlay");
					});
					fetchOfferWithItemsById(this.offerId, this).then(
						response => {
							this.offeredProducts = response.products;
						}
					);
					this.resetFlagsAfterOfferSave();

					this.$router.push({
						name: offer.routeName,
						params: {
							offerId: this.offerId,
							clientId: this.clientId,
							locationId: this.locationId,
						},
					});
				} catch (error) {
					// Handle error, e.g., display an error message or perform alternative actions
					console.error(error);
					emitter.emit("trigger-overlay");
				}
			}
		},
		/**
		 * Resets various flags related to the offer state and UI indications post saving an offer.
		 * This includes resetting product change flags, save offer click indicators, and offer price list change flags.
		 * Additionally, it handles resetting location change flags and description requirements for rooms
		 * if applicable, ensuring the UI state reflects the latest saved state of an offer.
		 *
		 * The method performs the following actions:
		 * - Resets the flags indicating if products have changed, if the save offer button was clicked,
		 *   and if there has been a change in the offer's price list.
		 * - If the location has been changed (indicated by `isLocationChanged`), this flag is also reset.
		 * - For each room in `roomsDetails` (if present and is an array), it resets the flag indicating
		 *   if a description is needed for each room.
		 * - Directly resets the `isDescriptionNeeded` flag on `roomsDetails` if it exists.
		 *
		 * This method is typically called after an offer is successfully saved or created,
		 * to ensure the application's state is correctly updated to reflect that no pending changes
		 * need to be saved or addressed.
		 *
		 * @see createOffer - Method where `resetFlagsAfterOfferSave` is called after creating an offer.
		 * @see saveOffer - Similar usage as in `createOffer`, for when an offer is saved.
		 */
		resetFlagsAfterOfferSave() {
			this.isProductsChanged = false;
			this.isSaveOfferClicked = false;
			this.isChangedOfferPriceList = false;
			if (this.location.isLocationChanged) {
				this.location.isLocationChanged = false;
			}

			// emitting event for setting showOnlyOfferQty on true in ProductTable
			emitter.emit("set-products-with-quantity-true");

			// Safely reset roomsDetails flags according to new version increment requirements
			if (this.$refs.roomsDetails) {
				// Check if roomsDetails has a rooms property and it is an array
				if (Array.isArray(this.$refs.roomsDetails.rooms)) {
					this.$refs.roomsDetails.rooms.forEach(room => {
						// Safely set isDescriptionNeeded to false if room exists
						if (room) {
							room.isDescriptionNeeded = false;
						}
					});
				}
				// Directly set isDescriptionNeeded on roomsDetails if it exists
				if ("isDescriptionNeeded" in this.$refs.roomsDetails) {
					this.$refs.roomsDetails.isDescriptionNeeded = false;
				}
			}
		},
		/**
		 * Handles specific actions for 'OfferVMC'.
		 * If a new version of the room details is required, it sets the description dialog to true.
		 * Otherwise, it saves the location details.
		 */
		handleOfferVMCAction() {
			if (this.$refs.roomsDetails.isNewVersionRequired) {
				this.$refs.roomsDetails.setDescriptionDialogTrue();
			} else {
				this.$refs.roomsDetails.saveLocation();
			}
		},
		async handleOfferIPAAction() {
			if (this.$refs.roomsDetails.isNewVersionRequired) {
				this.$refs.roomsDetails.setDescriptionDialogTrue();
				return;
			}

			// Sync IPA room data (circuit_length_ipa, circuit_no, pipe_diameter, etc.) from
			// RoomsDetailsIPA into location.rooms before saving. Locations created from
			// other offer types have null for these fields; without this, we'd either skip
			// saving (and dimensioning PDF has no data) or send stale nulls and overwrite DB.
			if (this.$refs.roomsDetails?.emitLocationUpdate) {
				this.$refs.roomsDetails.emitLocationUpdate(true, false);
			}

			await this.saveLocation();
		},
		/**
		 * Updates the offered and offer products with new products data and marks that the products have changed.
		 * @param {Array} products - The new products data to update.
		 */
		updateOfferProducts(products) {
			this.offeredProducts = products;
			this.offerProducts = products;
			this.isProductsChanged = true;
		},
		/**
		 * Updates the payment terms of the offer.
		 * @param {Object} paymentTerms - The new payment terms data to update.
		 */
		updatePaymentTerms(paymentTerms) {
			this.offerPaymentTerms = paymentTerms;
			this.isProductsChanged = true;
		},
		/**
		 * Updates various fields of the offer information.
		 * This can include notes, price list ID, totals and discount values.
		 * @param {Object} data - An object containing the offer data fields to update.
		 */
		updateOfferData(data) {
			// check if data.notes not undefined
			if (data.notes) {
				this.offerInformation.notes = data.notes;
				this.isProductsChanged = true;
			}
			// check if data.price_list_id not undefined
			if (data.price_list_id) {
				this.offerInformation.price_list_id = data.price_list_id;
			}
			// check if data.discount not undefined
			if (data.discount || data.discount === 0) {
				this.offerInformation.discount = data.discount;
				this.discount = data.discount;
			}
			// check if data.totalFinalPrice and data.totalPriceWithoutDiscount exists, if they do assign them
			if (data.totalFinalPrice) {
				this.offerInformation.totalFinalPrice = data.totalFinalPrice;
			}
			if (data.totalPriceWithoutDiscount) {
				this.offerInformation.totalPriceWithoutDiscount =
					data.totalPriceWithoutDiscount;
			}
			if (data.isDiscountMixed) {
				this.offerInformation.isDiscountMixed = data.isDiscountMixed;
			}
			if (data.selectedCustomerType) {
				this.offerInformation.selectedCustomerType =
					data.selectedCustomerType;
				this.isProductsChanged = true;
			}
		},
		/**
		 * Compares two objects for deep equality.
		 * Checks if both objects have the same keys and values, recursively comparing nested objects.
		 *
		 * @function objectsAreEqual
		 * @param {Object} objA - The first object to compare.
		 * @param {Object} objB - The second object to compare.
		 * @returns {boolean} - Returns true if the objects are deeply equal, false otherwise.
		 */
		objectsAreEqual(objA, objB) {
			// If both are primitive types or null or undefined
			if (objA === objB) return true;

			// If one of them is null or undefined
			if (!objA || !objB) return false;

			// If one of them is not an object
			if (typeof objA !== "object" || typeof objB !== "object")
				return false;

			let keysA = Object.keys(objA);
			let keysB = Object.keys(objB);

			if (keysA.length !== keysB.length) return false;

			return keysA.every(key => {
				if (!Object.prototype.hasOwnProperty.call(objB, key))
					return false;
				return this.objectsAreEqual(objA[key], objB[key]);
			});
		},
		/**
		 * Retrieves a product from the list of products based on the given product code.
		 *
		 * @function getUnitProduct
		 * @param {string} unitProductCode - The product code to search for.
		 * @param {Array} products - The list of products to search in.
		 * @returns {Object|undefined} - Returns a copy of the matching product object, or undefined if not found.
		 */
		getUnitProduct(unitProductCode, products) {
			let unitProductIndex = products.findIndex(
				item => item.product_code === unitProductCode
			);

			if (unitProductIndex !== -1) {
				return { ...products[unitProductIndex] };
			}
		},
		/**
		 * Processes the product requirements and matches them to available products.
		 * Iterates through requirements and products to find matching items and updates the quantities.
		 * Adds matched products to the resultedProducts array or recommendedProducts array.
		 *
		 * @function getProducts
		 * @param {Object} requirementsObj - The object containing product requirements.
		 * @param {Array} products - The list of available products.
		 */
		getProducts(requirementsObj, products) {
			let newProductAdded = true;
			while (newProductAdded) {
				newProductAdded = false;

				for (let requirement of requirementsObj.requirements) {
					if (requirement.processed) continue;

					for (let product of products) {
						let isMatch = this.matchRequirementToProduct(
							requirement,
							product
						);

						if (isMatch) {
							if (
								requirement.quantity &&
								!requirement.isRecommendedProduct
							) {
								let productQuantity =
									this.offerType?.type === "IPA"
										? parseFloat(requirement.quantity)
										: Math.round(requirement.quantity);
								requirement.processed = true;
								newProductAdded = true;
								product.quantity = productQuantity;

								if (
									requirement.unitId !== undefined &&
									requirement.unitId !== null
								) {
									product.unitId = requirement.unitId;
								}
								if (requirement.apartment)
									product.apartment = requirement.apartment;
								if (requirement.floor)
									product.floor = requirement.floor;
								if (
									!requirement.product_code &&
									product.product_code
								) {
									requirement.product_code =
										product.product_code;
								}

								this.processProduct(cloneDeep(product));
								this.resultedProducts.push(cloneDeep(product));

								// IMPORTANT:
								// A single requirement should map to a single SKU.
								// If multiple products accidentally share the same specifications,
								// continuing the loop would duplicate quantities (seen on IPA foil).
								break;
							} else if (requirement.isRecommendedProduct) {
								requirement.processed = true;
								let code = JSON.parse(
									JSON.stringify(product.product_code)
								);
								// Per-unit recommended (e.g. different automation per floor) only when compartmentation is 1 or 2.
								const comp =
									this.getEffectiveCompartmentation();
								if (
									this.recommendedProductsByUnit != null &&
									requirement.unitId != null &&
									requirement.unitId !== undefined &&
									(comp === 1 || comp === 2)
								) {
									if (
										!this.recommendedProductsByUnit[
											requirement.unitId
										]
									) {
										this.recommendedProductsByUnit[
											requirement.unitId
										] = [];
									}
									this.recommendedProductsByUnit[
										requirement.unitId
									].push(code);
								} else {
									this.recommendedProducts.push(code);
								}
								break;
							} else {
								requirement.processed = true;
								product.quantity = Math.round(
									requirement.quantity
								);
								this.processProduct(cloneDeep(product));
								this.resultedProducts.push(cloneDeep(product));
								newProductAdded = true;

								break;
							}
						}
					}
				}
			}
		},

		/**
		 * Matches a product to a requirement based on its specifications.
		 * Compares the product's specifications against the requirement's type, subtype, and other criteria.
		 * Returns true if the product meets all the requirement criteria, false otherwise.
		 *
		 * @function matchRequirementToProduct
		 * @param {Object} requirement - The requirement object containing product specifications.
		 * @param {Object} product - The product object with specifications to match against.
		 * @returns {boolean} - Returns true if the product matches the requirement, otherwise false.
		 */
		matchRequirementToProduct(requirement, product) {
			let enableDebugLogs = false; // Set this to false to disable logs
			const requirementType = requirement.type;
			if (enableDebugLogs) {
				console.log(`Product ID ${product.id}: ${product.name}`);
			}

			if (requirementType !== product.specifications.type) {
				if (enableDebugLogs) {
					console.log(
						`Product ID ${product.id}: Type mismatch - requirement type ${requirementType} does not match product type ${product.specifications.type}`
					);
				}
				return false;
			}
			if (
				requirement.subtype &&
				product.specifications.subtype &&
				requirement.subtype !== product.specifications.subtype
			) {
				if (enableDebugLogs) {
					console.log(
						`Product ID ${product.id}: Subtype mismatch - requirement subtype ${requirement.subtype} does not match product subtype ${product.specifications.subtype}`
					);
				}
				return false;
			}

			for (let key in requirement) {
				if (
					key === "processed" ||
					key === "quantity" ||
					key === "isRecommendedProduct" ||
					key === "unitId" ||
					key === "pUnitId" ||
					key === "floor" ||
					key === "apartment"
				)
					continue;

				if (
					!Object.prototype.hasOwnProperty.call(
						product.specifications,
						key
					)
				) {
					if (enableDebugLogs) {
						console.log(
							`Product ID ${product.id}: Key missing - product does not have key ${key}`
						);
					}
					return false;
				}

				if (
					isObject(requirement[key]) &&
					isObject(product.specifications[key])
				) {
					if (
						!this.objectsAreEqual(
							requirement[key],
							product.specifications[key]
						)
					) {
						if (enableDebugLogs) {
							console.log(
								`Product ID ${
									product.id
								}: Object mismatch - requirement ${key} ${JSON.stringify(
									requirement[key]
								)} does not match product ${key} ${JSON.stringify(
									product.specifications[key]
								)}`
							);
						}
						return false;
					}
				} else if (
					Array.isArray(requirement[key]) &&
					Array.isArray(product.specifications[key])
				) {
					if (
						!requirement[key].some(reqItem =>
							product.specifications[key].includes(reqItem)
						)
					) {
						if (enableDebugLogs) {
							console.log(
								`Product ID ${
									product.id
								}: Array mismatch - requirement ${key} ${JSON.stringify(
									requirement[key]
								)} does not match product ${key} ${JSON.stringify(
									product.specifications[key]
								)}`
							);
						}
						return false;
					}
				} else if (Array.isArray(product.specifications[key])) {
					if (
						!product.specifications[key].includes(requirement[key])
					) {
						if (enableDebugLogs) {
							console.log(
								`Product ID ${
									product.id
								}: Array mismatch - requirement ${key} ${
									requirement[key]
								} is not included in product ${key} ${JSON.stringify(
									product.specifications[key]
								)}`
							);
						}
						return false;
					}
				} else if (isObject(product.specifications[key])) {
					if (
						!this.objectsAreEqual(
							requirement[key],
							product.specifications[key]
						)
					) {
						if (enableDebugLogs) {
							console.log(
								`Product ID ${
									product.id
								}: Object mismatch - requirement ${key} ${JSON.stringify(
									requirement[key]
								)} does not match product ${key} ${JSON.stringify(
									product.specifications[key]
								)}`
							);
						}
						return false;
					}
				} else if (requirement[key] !== product.specifications[key]) {
					if (enableDebugLogs) {
						console.log(
							`Product ID ${product.id}: Value mismatch - requirement ${key} ${requirement[key]} does not match product ${key} ${product.specifications[key]}`
						);
					}
					return false;
				}
			}
			return true;
		},

		addRecommendedProducts(existingProducts, products) {
			existingProducts.forEach(existingProduct => {
				if (existingProduct.recommendations) {
					existingProduct.recommendations.forEach(recommendation => {
						let recommendationExists =
							this.requirementsObj.requirements.some(req => {
								if (!req.quantity) {
									return false;
								}
								return this.compareRequirements(
									req,
									recommendation
								);
							});

						if (!recommendationExists) {
							let newRecommendation = JSON.parse(
								JSON.stringify(recommendation)
							);
							newRecommendation.isRecommendedProduct = true;
							// Scope recommendation to same unit as the product (e.g. floor automation)
							newRecommendation.unitId =
								existingProduct.unitId ?? null;
							this.requirementsObj.requirements.push(
								newRecommendation
							);
							this.recommendedProductAdded = true;
						}
					});
				}
			});

			if (this.recommendedProductAdded) {
				this.getProducts(this.requirementsObj, products);
			}
		},
		/**
		 * Reassigns subcategories to products based on their main category and product categories.
		 * Filters category assignments and assigns a default subcategory if no match is found.
		 *
		 * @function reassignSubCategories
		 * @param {Array} products - The array of products to reassign subcategories to.
		 * @returns {Array} - Returns the array of products with reassigned subcategories.
		 */
		reassignSubCategories(products) {
			return products.map(product => {
				// Filter out the category_assignments that don't match the productCategories
				const filteredAssignments = product.category_assignments.filter(
					assignment =>
						this.offerType.productCategories.includes(
							assignment.main_category.name
						)
				);
				product.assigned_sub_category = filteredAssignments[0]
					? filteredAssignments[0]?.sub_category?.name
					: "Alte produse";

				// Return the product with adjusted category_assignments
				return {
					...product,
				};
			});
		},
		/**
		 * Matches products from a primary array with those from a secondary array based on the product code.
		 * If a matching product is found, it updates the primary product's quantity and visibility.
		 * Also assigns a specific subcategory for a product with a particular product code.
		 *
		 * @function matchProducts
		 * @param {Array} primaryArray - The array of primary products to be updated.
		 * @param {Array} secondaryArray - The array of secondary products to find matches in.
		 * @returns {Array} - Returns the updated primary array with matched quantities and show properties.
		 */
		matchProducts(primaryArray, secondaryArray) {
			primaryArray = JSON.parse(JSON.stringify(primaryArray));
			primaryArray.forEach(primaryProduct => {
				const matchingProduct = secondaryArray.find(
					secondaryProduct =>
						secondaryProduct.product_code ===
						primaryProduct.product_code
				);

				if (matchingProduct) {
					if (primaryProduct.product_code === "913.01.62") {
						primaryProduct.assigned_sub_category =
							"Produse Etapa 2";
					}
					// Setting the show property based on the quantity of the product (if it's 0, then it's true)
					primaryProduct.quantity = matchingProduct.quantity;
					primaryProduct.show = matchingProduct.quantity === 0;
				}
			});

			return primaryArray;
		},
		/**
		 * Fetches a list of priced products from the server and stores it in session storage.
		 * If the session storage already contains the price list, it uses that data instead.
		 * The method handles any errors during the fetching process and logs them.
		 */
		async fetchPriceListProducts(priceListType) {
			// Check if the session storage PRICE_LIST_PRODUCTS is empty, if empty fetch from the server
			let priceListProducts = JSON.parse(
				sessionStorage.getItem("PRICE_LIST_PRODUCTS")
			);
			if (!priceListProducts) {
				console.log("Fetching products from the server");
				try {
					const response = await apiClient.get(
						"/api/price_lists/items/",
						{
							params: {
								type: priceListType,
							},
						}
					);
					if (!response || !response.data) {
						throw new Error("Failed to fetch product data");
					}
					sessionStorage.setItem(
						"PRICE_LIST_PRODUCTS",
						JSON.stringify(response.data)
					);
					return response.data;
				} catch (error) {
					console.error(
						"Error fetching product data:",
						error.response ? error.response.data : error.message
					);
					showAlertModal(
						this.$store,
						"A intervenit o eroare la preluarea produselor din lista de prețuri. Vă rugăm reîmprospătați pagina.",
						"danger",
						12000,
						error
					);
					throw error;
				}
			} else {
				return priceListProducts;
			}
		},
		/**
		 * Sets the quantity of each product in the array to zero.
		 *
		 * @function setZeroQtyForBackendProducts
		 * @param {Array} products - The array of products to update.
		 * @returns {Array} - Returns the updated array of products with quantity set to zero.
		 */
		setZeroQtyForBackendProducts(products) {
			products.forEach(product => {
				product.quantity = 0;
			});
			return products;
		},
		/**
		 * Processes a product's requirements and updates the global requirements object.
		 * Multiplies the product quantity with the requirement quantity, checks if the requirement exists,
		 * and adds or updates it in the requirements list. Logs are available if logging is enabled.
		 *
		 * @function processProduct
		 * @param {Object} product - The product to process, containing requirements and quantity.
		 */
		processProduct(product) {
			// Check if product name contains 'cot' to enable logging
			const enableLogging = false;

			if (enableLogging) {
				console.log("Processing product:", product); // Log the product being processed
			}

			if (product.requirements && Array.isArray(product.requirements)) {
				product.requirements.forEach(req => {
					// multiply the req.quantity with the product.quantity while adding error handling
					let totalQuantity = req.quantity * product.quantity;

					if (enableLogging) {
						console.log("Checking requirement:", req); // Log the current requirement being checked
					}

					const existingRequirementIndex =
						this.requirementsObj.requirements.findIndex(r =>
							this.compareRequirements(r, req)
						);

					if (
						existingRequirementIndex !== -1 &&
						!this.requirementsObj.requirements[
							existingRequirementIndex
						].processed
					) {
						if (enableLogging) {
							console.log(
								`Found existing requirement at index ${existingRequirementIndex}. Updating quantity.`
							); // Log when an existing requirement is found
							// show new quantity
							console.log(
								"Previous quantity:",
								this.requirementsObj.requirements[
									existingRequirementIndex
								].quantity
							);
						}
						// Overwriting the value at the found index with the updated requirement
						this.requirementsObj.requirements[
							existingRequirementIndex
						].quantity += totalQuantity;
					} else {
						if (enableLogging) {
							console.log(
								"No existing requirement found. Adding new requirement:",
								req
							); // Log when no existing requirement is found
						}
						req.quantity =
							req.quantity !== null && req.quantity !== undefined
								? totalQuantity
								: 1;
						req = JSON.parse(JSON.stringify(req));
						this.requirementsObj.requirements.push(req);
					}
				});
			} else {
				if (enableLogging) {
					console.warn("No requirements found for product:", product); // Log a warning if no requirements are present
				}
			}
		},
		/**
		 * Processes conditions for a list of products. If a product contains conditions, it applies them.
		 * Skips already processed products and marks products as processed after applying conditions.
		 * Handles errors for invalid condition functions.
		 *
		 * @function processProductConditions
		 * @param {Array} products - The array of products with conditions to process.
		 */
		processProductConditions(products) {
			for (let i = 0; i < products.length; i++) {
				let product = products[i];
				// Skip processing if the product has already been processed
				if (product.processed) {
					continue;
				}

				if (product.conditions && product.conditions.length > 0) {
					for (let j = 0; j < product.conditions.length; j++) {
						// Check if the condition is a function and not null
						if (typeof product.conditions[j] === "function") {
							try {
								product.conditions[j](this);
							} catch (error) {
								console.error(
									`Error processing condition ${j} for product ${product.id}:`,
									error
								);
							}
						}
					}
				}

				// Mark the product as processed
				product.processed = true;
			}
		},
		/**
		 * Processes the resulted products by updating their quantities or adding them to the finalResultedProducts array.
		 * If a product already exists in finalResultedProducts, its quantity is updated.
		 * The processed products are then removed from the resultedProducts array.
		 *
		 * @function processResultedProducts
		 */
		processResultedProducts() {
			const indicesToRemove = [];
			this.resultedProducts.forEach((product, index) => {
				const existingProductIndex =
					this.finalResultedProducts.findIndex(
						p => p.product_code === product.product_code
					);

				if (existingProductIndex !== -1) {
					// Update quantity in finalResultedProducts
					this.finalResultedProducts[existingProductIndex].quantity +=
						product.quantity !== undefined &&
						product.quantity !== null
							? product.quantity
							: 1;

					// Store the index to remove this product from resultedProducts
					indicesToRemove.push(index);
				} else {
					// Add new product to finalResultedProducts
					this.finalResultedProducts.push({
						...product,
						quantity: product.quantity,
					});
				}
			});

			// Remove the products from resultedProducts
			this.resultedProducts = this.resultedProducts.filter(
				(_, index) => !indicesToRemove.includes(index)
			);
		},
		/**
		 * Compares two requirement objects to check if they are equivalent, excluding the 'quantity' and 'processed' properties.
		 * If both objects have the same keys and values, the function returns true, otherwise false.
		 * Recursively compares nested objects.
		 *
		 * @function compareRequirements
		 * @param {Object} objA - The first requirement object to compare.
		 * @param {Object} objB - The second requirement object to compare.
		 * @returns {boolean} - Returns true if the objects are equivalent, otherwise false.
		 */
		compareRequirements(objA, objB) {
			const keysA = Object.keys(objA).filter(
				key => key !== "quantity" && key !== "processed"
			);
			const keysB = Object.keys(objB).filter(
				key => key !== "quantity" && key !== "processed"
			);

			if (keysA.length !== keysB.length) {
				return false;
			}

			for (let key of keysA) {
				if (
					typeof objA[key] === "object" &&
					typeof objB[key] === "object"
				) {
					if (!this.compareRequirements(objA[key], objB[key])) {
						return false;
					}
				} else if (objA[key] !== objB[key]) {
					return false;
				}
			}
			return true;
		},
		/**
		 * Adds or updates the offeredProducts array with the finalResultedProducts.
		 * Used by all offer types (PDC, VMC, Plumbing, Vacuum, IPA).
		 * - Non-IPA (no compartmentation): merges with existing offeredProducts, respects manual_added.
		 * - IPA with compartmentation 0: flat list, replace all (no unit grouping).
		 * - IPA with compartmentation 1 or 2: groups by unitId (floors/apartments), offeredProducts is an object keyed by unit.
		 * Filters out products with null/undefined quantity and shows success alert.
		 *
		 * @function addOrUpdateOfferedProducts
		 */
		addOrUpdateOfferedProducts() {
			const compartmentation = this.getEffectiveCompartmentation();
			// Compartmentation (unit grouping) is an IPA-only concept.
			// Other offer types (VMC, Plumbing, etc.) may share the same location and must keep a flat products array.
			const isIpa = this.$options?.name === "OfferIPA";
			const hasCompartmentation =
				isIpa && (compartmentation === 1 || compartmentation === 2);

			const withQuantity = item =>
				item.quantity !== null && item.quantity !== undefined;

			if (hasCompartmentation) {
				const filtered = (this.finalResultedProducts || []).filter(
					withQuantity
				);
				const existing =
					this.offeredProducts &&
					typeof this.offeredProducts === "object" &&
					!Array.isArray(this.offeredProducts)
						? this.offeredProducts
						: {};
				const grouped = {};
				for (const p of filtered) {
					const key =
						p.unitId === 0 || p.unitId ? p.unitId : "no-unit";
					if (!grouped[key]) grouped[key] = [];
					const existingItem = (existing[key] || []).find(
						x => x.product_code === p.product_code
					);
					if (existingItem && existingItem.manual_added) {
						grouped[key].push(existingItem);
					} else {
						grouped[key].push(p);
					}
				}
				for (const key of Object.keys(existing)) {
					if (!grouped[key]) grouped[key] = [];
					for (const item of existing[key] || []) {
						if (
							item.manual_added &&
							!grouped[key].some(
								x => x.product_code === item.product_code
							)
						) {
							grouped[key].push(item);
						}
					}
				}
				this.offeredProducts = grouped;
				this.offerProducts = Object.values(grouped)
					.flat()
					.filter(withQuantity);
			} else if (compartmentation === 0) {
				const filtered = (this.finalResultedProducts || []).filter(
					withQuantity
				);
				const existingList = Array.isArray(this.offeredProducts)
					? this.offeredProducts
					: [];
				const merged = [];
				for (const p of filtered) {
					const existingIndex = existingList.findIndex(
						x => x.product_code === p.product_code
					);
					if (
						existingIndex !== -1 &&
						existingList[existingIndex].manual_added
					) {
						merged.push(existingList[existingIndex]);
					} else {
						merged.push(p);
					}
				}
				for (const item of existingList) {
					if (
						item.manual_added &&
						!merged.some(x => x.product_code === item.product_code)
					) {
						merged.push(item);
					}
				}
				this.offeredProducts = merged.filter(withQuantity);
				this.offerProducts = [...this.offeredProducts];
			} else {
				// Non-IPA: merge with existing, respect manual_added
				if (this.offeredProducts) {
					this.finalResultedProducts.forEach(resultedProduct => {
						const existingIndex = this.offeredProducts.findIndex(
							offeredProduct =>
								offeredProduct.product_code ===
								resultedProduct.product_code
						);
						if (existingIndex !== -1) {
							if (
								!this.offeredProducts[existingIndex]
									.manual_added
							) {
								this.offeredProducts[existingIndex] =
									resultedProduct;
							}
						} else {
							this.offeredProducts.push(resultedProduct);
						}
					});
				} else {
					this.offeredProducts = (
						this.finalResultedProducts || []
					).filter(withQuantity);
				}
				this.offeredProducts =
					this.offeredProducts.filter(withQuantity);
				this.offerProducts = [...this.offeredProducts];
			}

			this.isProductsChanged = true;
			setTimeout(() => {
				emitter.emit("trigger-overlay");
				showAlertModal(
					this.$store,
					"Produsele au fost calculate cu succes!",
					"success",
					3000
				);
			}, 50);
		},
	},
	watch: {
		isProductsChanged: function () {
			this.isDifferentCreator = this.checkDifferentOfferCreator();
			if (this.isDifferentCreator) {
				this.isTechnicalCreator = this.checkIfTechnicalCreator();
			}
		},
		discount: function (oldVal, newVal) {
			if (newVal < 0) {
				this.discount = null;
			} else if (newVal > 100) {
				this.discount = 100;
			}
		},
		offer(newVal) {
			if (newVal) {
				this.discount = Number(newVal.discount);
			}
		},
	},
};
